import * as each from 'lodash/each';
import moment from 'moment';

const getMonthView = (num) => (num < 10 ? `0${num}` : num);
export const getCardMonthOptions = () => {
    const months = [];

    const monthShort = moment.monthsShort();

    each(monthShort, (mShort, key) => {
        const value = key + 1;
        const stringValue = getMonthView(value);

        months.push({
            key,
            value,
            label: `${mShort} (${stringValue})`
        });
    });

    return months;
};

export const getCardYearsOptions = () => {
    const years = [];
    const currentYear = parseInt(moment().format('YYYY'), 10);

    for (let i = 0; i < 20; i++) {
        const year = currentYear + i;

        years.push({
            key: year,
            value: year,
            label: year
        });
    }

    return years;
};
